import builder from '../builder';
import StyleTwoPinHome from '../../streamline-icons/light/style-two-pin-home.svg';

export default builder('IconStyleTwoPinHomeLight', StyleTwoPinHome);
